'use strict';

angular.module('docketbook')
.controller('companySettingsBillingController', function(userService, billingService, $scope, Restangular, $q, $state, $window, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-Billing Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.mode = 'list';

  $scope.selected = [];

  $scope.billingDetails = billingService.billingDetails;
  billingService.getBillingDetails(function(details) {
    $scope.billingDetails = details
  })

  $scope.cancellationReason = '';

  $scope.capitaliseBillingCycle = function(cycle) {
    const convert = ([first, ...rest]) => [first.toUpperCase(), ...rest].join('')
    return cycle ? convert(cycle) : null
  }

  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'name'
  };
  $scope.listCount = 0;

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.downloadInvoice = function(invoice) {
    var url = DOCKETBOOK_API_URL + "/" + $scope.urlVersion + "/organisations/" + $scope.currentOrg.id + "/invoices/" + invoice.id;
    window.open(url);
  }

  $scope.selectNewPlan = function() {
    $scope.selectPlan(function() {
      billingService.getBillingDetails();
    }, null, "Selected New Plan For Company");
  }

  $scope.updateCardDetails = function() {
    mixpanel.track("Updated Card Details For Company");
    $scope.selectPlanUpdateCard(function() {
      billingService.getBillingDetails();
    });
  }

  $scope.saveBillingContact = function(billingDetails) {
    billingDetails.contact.loading = true;
    billingService.updateOrganisationBillingContact($scope.currentOrg.id, billingDetails.contact, function(updatedContact) {
      billingDetails.contact.loading = false;
    }, function(err) {
      billingDetails.contact.loading = false
      $scope.alertService.presentAlert('error','Oops.', 'Something went wrong when we tried to update your billing contact details. Please try again.');
    });
  }

  /*$scope.updateCreditCard = function() {
    window.Stripe.createToken({
      number: $scope.cardUpdate.creditCardNumber,
      cvc: $scope.cardUpdate.cvc,
      exp_month: $scope.cardUpdate.expiry_month,
      exp_year: $scope.cardUpdate.expiry_year,
      address_zip: $scope.cardUpdate.zip
    }, function(result, responseObj) {
      if (!responseObj.error) {
        var billingObj = {token : responseObj.id};
        billingService.updateOrganisationBilling($scope.currentOrg.id, billingObj, function() {
          $scope.getBillingDetails();
          $scope.cardUpdate = {};
          $scope.alertService.presentAlert('success','Cool!','Card details updated!');
        }, function(err) {
          $scope.alertService.presentAlert('error', 'Bugger :/', 'Updating card details failed.');
        });
      } else {
        $scope.alertService.presentAlert('error','Bugger :/', 'Getting stripe card token failed!');
      }
    });
  }

  $scope.updatePlan = function() {
    var billingObj = { plan: $scope.planUpdate.plan };
    billingService.updateOrganisationBilling($scope.currentOrg.id, billingObj, function() {
      $scope.getBillingDetails();
      $scope.planUpdate = {};
      $scope.alertService.presentAlert('success','Cool!','Plan details updated!');
    }, function(err) {
      $scope.alertService.presentAlert('error','Bugger :/', 'Updating plan details failed!');
    });
  }*/

});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/billing.js